export function LoadingPlan() {
  return (
    <div className="relative flex h-full w-full">
      <div className="flex h-full w-2/5 max-w-[400px] flex-col border-r">
        <div className="flex h-10 w-full items-center gap-2 border-b px-4 text-lg font-medium">
          <span className="iconify lucide--list-check h-4 w-4" />
          Plan
        </div>
        <div className="flex flex-1 flex-col justify-between">
          <div className="mx-4 mt-10 flex h-[400px] flex-col items-center justify-center gap-4 rounded-lg border-2">
            <p className="text-sm text-gray-500">Loading plan...</p>
            <span className="iconify lucide--loader-circle h-3 w-3 animate-spin" />
          </div>
        </div>
      </div>

      <div className="mx-10 mt-6 min-w-0 flex-1 space-y-6">
        <div className="flex items-center gap-2 font-medium text-gray-800">
          <span className="iconify lucide--clock h-4 w-4 text-teal-500" />
          Initializing
        </div>
        <div className="flex max-h-96 items-center gap-3 overflow-y-auto rounded-md border border-gray-100 bg-gray-50/50 p-4">
          <span className="iconify lucide--circle h-2 w-2 text-teal-500" />
          <p className="min-w-0 flex-1 space-y-1 border-b border-dashed text-xs leading-relaxed text-gray-700">
            <b>Loading</b> your question and preparing the analysis...
          </p>
        </div>
      </div>
    </div>
  );
}
